import React, { useEffect } from 'react';
import { LessonPlannerView } from './components';
import { useLocation } from 'react-router-dom';
import { batch, useDispatch, useSelector } from 'react-redux';
import { parseQueryParams } from 'util/query-params-util';
import { fetchUserClassrooms } from 'state/modules/entity/custom/classrooms/thunks';
import { fetchLessonPlan } from 'state/modules/entity/thunks/lesson-planner';
import {
  fetchTeachingOrder,
  getProductConfiguration
} from 'state/modules/entity/thunks/teaching-order';
import { setLessonPlannerNavbarAttribute } from 'state/modules/lessonPlanner/thunks';
import { AppStoreState, LESSON_PLANNER_MODE } from 'types';

const LessonPlanner = () => {
  const dispatch = useDispatch() as any;
  const location = useLocation();
  const productConfig = useSelector(({ entity }: AppStoreState) => entity.productConfig);

  useEffect(() => {
    const queryParam = parseQueryParams(location.search);

    const init = () => {
      batch(async () => {
        await dispatch(fetchUserClassrooms());
        await dispatch(fetchLessonPlan());
        await dispatch(fetchTeachingOrder());
        if (!productConfig?.emptyDates?.length || !productConfig?.skipDates?.length) {
          await dispatch(getProductConfiguration());
        }
      });
    };

    if (!queryParam || queryParam.active === 'true') {
      init();
      dispatch(setLessonPlannerNavbarAttribute('mode', LESSON_PLANNER_MODE.LESSON_PLANNER));
    } // eslint-disable-next-line
  }, [dispatch, location.search]);

  return <LessonPlannerView />;
};

export default LessonPlanner;
